import { z } from "zod";
import { stepGetBaseSchema } from "./stepGetBaseSchema";

export const contextUpdateStepStepGetSchema = z.object({
  ...stepGetBaseSchema.shape,
  type: z.literal("CONTEXT_UPDATE_STEP"),
  step_data: z.object({
    variables: z.array(
      z.object({
        type: z.enum([
          "array",
          "boolean",
          "number",
          "object",
          "string",
          "time",
          // These show up in the data, but probably shouldn't be here.
          "",
          "String",
          "aray",
        ]),
        definition: z.string(),
        name: z.string(),
      })
    ),
  }),
});
